import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { GuidedTourService } from './guided-tour.service';

@Component({
  selector: 'thehubz-guided-tour-button',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './guided-tour-button.component.html',
  styleUrls: ['./guided-tour-button.component.scss'],
})
export class GuidedTourButtonComponent implements OnInit, OnDestroy {
  private guidedTourSubs?: Subscription;

  isTourReady = false;

  constructor(protected guidedTourService: GuidedTourService) {}

  ngOnInit(): void {
    this.guidedTourSubs = this.guidedTourService.isInitialized$.subscribe((isReady) => {
      if (isReady) this.isTourReady = isReady;
    });
  }

  ngOnDestroy(): void {
    this.guidedTourSubs?.unsubscribe();
  }

  start() {
    this.guidedTourService.start();
  }
}
